import { render } from "./Services5Section.vue?vue&type=template&id=2be8053e&scoped=true"
import script from "./Services5Section.vue?vue&type=script&lang=js"
export * from "./Services5Section.vue?vue&type=script&lang=js"

import "./Services5Section.vue?vue&type=style&index=0&id=2be8053e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be8053e"]])

export default __exports__